/** Replace this page with another site's URL. The current history entry goes with it, so Back
 *  does not return to a page that already did its one-shot work (the MCP sign-in handoff).
 *  Its own module so tests can mock it: jsdom cannot navigate. */
export function leaveAppFor(url: string): void {
  window.location.replace(url);
}
